import { ThemeOptions } from "@mui/material/styles";

import palette from "./main.scss";

import "./../fonts/TelstraDisplay.scss";
import "./../fonts/TelstraText.scss";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: palette.primary,
      dark: palette.primary80,
    },
    secondary: {
      main: palette.secondary,
    },
    tertiary: {
      main: palette.tertiary,
      light: palette.tertiary20,
      dark: palette.tertiary40,
    },
  },
  typography: {
    fontFamily: "Telstra Display, Roboto, Helvetica, Arial, sans-serif",
    button: {
      textTransform: "none",
    },
    subtitle2: {
      fontFamily: "Telstra Text, Roboto, Helvetica, Arial, sans-serif",
    },
  },
};
